import type { TPrefillInfoParams } from "./types";

// Either prefill, affiliate or stored data should be used to prefill order, not all of them
const filterPrefillParams = ({
  prefill,
  affiliate,
  userAddress,
  invoiceAddresses,
  storedData,
  packageSizes,
}: TPrefillInfoParams): TPrefillInfoParams => {
  const basePrefillData = { userAddress, invoiceAddresses, packageSizes };
  if (prefill) {
    return { ...basePrefillData, prefill };
  }
  if (affiliate) {
    return { ...basePrefillData, affiliate };
  }
  return { ...basePrefillData, storedData };
};
export default filterPrefillParams;
